<script setup lang="ts">
const props = defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  select: [type: 'voice' | 'video']
  cancel: []
}>()

function handleSelect(type: 'voice' | 'video') {
  emit('select', type)
}

function handleCancel() {
  emit('cancel')
}
</script>

<template>
  <Teleport to="body">
    <Transition name="dialog">
      <div
        v-if="props.show"
        fixed inset-0 z-300
        flex items-center justify-center
        bg="[rgba(0,0,0,0.5)]"
        backdrop-blur-sm
        @click.self="handleCancel"
      >
        <div
          bg="white dark:neutral-800"

          mx-4 max-w-sm w-full transform rounded-2xl p-6 shadow-2xl transition-all
        >
          <h2 mb-4 text-xl>
            选择通话方式
          </h2>

          <div flex="~ col" gap-3>
            <!-- 语音通话 -->
            <button

              flex items-center gap-4 rounded-xl p-4
              bg="neutral-100 hover:neutral-200 dark:neutral-700 dark:hover:neutral-600"
              transition="all duration-200"
              @click="handleSelect('voice')"
            >
              <div

                bg="primary-100 dark:primary-900"
                h-12 w-12 flex items-center justify-center rounded-full
              >
                <div i-carbon:phone-voice text-2xl text-primary-600 />
              </div>
              <div flex="~ col" flex-1 items-start>
                <span>语音通话</span>
                <span text-sm text-neutral-500>纯语音对话</span>
              </div>
              <div i-carbon:chevron-right text-neutral-400 />
            </button>

            <!-- 视频通话 -->
            <button

              flex items-center gap-4 rounded-xl p-4
              bg="neutral-100 hover:neutral-200 dark:neutral-700 dark:hover:neutral-600"
              transition="all duration-200"
              @click="handleSelect('video')"
            >
              <div

                bg="primary-100 dark:primary-900"
                h-12 w-12 flex items-center justify-center rounded-full
              >
                <div i-carbon:video text-2xl text-primary-600 />
              </div>
              <div flex="~ col" flex-1 items-start>
                <span>视频通话</span>
                <span text-sm text-neutral-500>带视觉描述</span>
              </div>
              <div i-carbon:chevron-right text-neutral-400 />
            </button>
          </div>

          <!-- 取消按钮 -->
          <button

            bg="transparent hover:bg-neutral-100 dark:hover:bg-neutral-700"

            mt-4 w-full rounded-xl py-3 text-neutral-600 dark:text-neutral-300
            transition="all duration-200"
            @click="handleCancel"
          >
            取消
          </button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.dialog-enter-active,
.dialog-leave-active {
 transition: opacity 0.3s ease;
}

.dialog-enter-from,
.dialog-leave-to {
 opacity: 0;
}

.dialog-enter-active > div,
.dialog-leave-active > div {
 transition: transform 0.3s ease;
}

.dialog-enter-from > div,
.dialog-leave-to > div {
 transform: scale(0.9) translateY(20px);
}
</style>
